
































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetTrophy extends Vue {
  @Prop({ default: '40' }) readonly width?: string;
  @Prop({ default: '40' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
